import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core';
import React from 'react';

const styles = {
  label: {
    fontSize: '13px',
  },
};

export default withStyles(styles)(props => (
  <FormControlLabel
    label={props.label}
    style={{
      marginLeft: 0,
      marginRight: 0,
      height: '100%',
    }}
    control={props.children}
    classes={{
      label: props.classes.label,
    }}
  />
));
